import { createSlice } from "@reduxjs/toolkit";
import { IInvoices } from "../types/invoices";
import { InvoicesApi } from "../Services/invoices";
import { AppThunk } from "../store/configureStore";
import {toast} from "react-toastify";
import I18n from "Services/i18n";

const ERROR_URL = 'errorPayment';

export type selectedFiltersType = {
  [key: string]: string;
};

export type PdfType = {
  id: number;
  file: string;
};

interface IInvoicesState {
  loading: boolean;
  data: IInvoices[];
  errors: any;
  selectedFilters: selectedFiltersType | null;
  pdf: PdfType;
}

const initialState: IInvoicesState = {
  loading: false,
  data: [],
  errors: {},
  selectedFilters: null,
  pdf: {} as PdfType,
};

const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setLoadingFalse: (state) => {
      state.loading = false;
    },
    setLoader: (state) => {
      state.loading = true;
      state.errors = initialState.errors;
    },
    setData: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.data = payload;
    },
    setError: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.errors = payload;
    },
    setFilters: (state, action) => {
      const { payload } = action;
      state.selectedFilters = payload;
    },
    setPDF: (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.pdf = {
        id: payload.id,
        file: payload.file,
      };
    },
  },
});

export const {
  setLoader,
  setData,
  setError,
  setFilters,
  setPDF,
  setLoadingFalse
} = invoicesSlice.actions;

export default invoicesSlice.reducer;

export const getInvoices = (
  queryParams?: selectedFiltersType
): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await InvoicesApi.get(queryParams);
    dispatch(setData(response));
  } catch (error) {
    dispatch(setError(error));
  }
};

export const getPdfFile = (id: number): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await InvoicesApi.getPdfFile(id);
    dispatch(
      setPDF({
        file: response.file,
        id,
      })
    );
  } catch (error) {
    dispatch(setError(error));
  }
};

export const payInvoice = (id: number): AppThunk => async (dispatch) => {
  dispatch(setLoader());
  try {
    const response = await InvoicesApi.payInvoice(id);
    if (response.paymentUrl.indexOf(ERROR_URL) !== -1) {
      toast.error(I18n.getStringByKey("error-payment"));
    } else {
      window.open(response.paymentUrl, "_blank");
    }
    dispatch(setLoadingFalse());
  } catch (error) {
    dispatch(setError(error));
  }
};
